// extracted by mini-css-extract-plugin
export default {"footerContainer":"internalFooter_footerContainer__FX8T8","footer":"internalFooter_footer__ZuM6r","icon":"internalFooter_icon__n5rjG","isActive":"internalFooter_isActive__dHcDn"};